
import Vue from 'vue';
import VRuntimeTemplate from 'v-runtime-template';
export default Vue.extend({
  components: {
    VRuntimeTemplate,
  },
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  computed: {
    compiledTemplate() {
      const template = this.data.replace(/a href/g, 'a rel="noopener noreferrer" href');
      return template;
    },
  },
});
